import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const darkwebScan = async (userId, query) => {
	try {
		const token = sessionStorage.getItem('authToken');
		const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/darkweb/scan`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
			},
			body: JSON.stringify({ query })
		});
		
		const payload = await response.json().catch(() => ({}));
		if (!response.ok) {
			throw new Error(
				payload.message || "Unable to complete the dark-web assessment"
			);
		}
		return payload;
	} catch (error) {
		console.error('Error running dark-web assessment:', error);
		throw error;
	}
};

export const updateDarkwebRemediation = async (
	userId,
	scanUuid,
	update
) => {
	const token = sessionStorage.getItem("authToken");
	const response = await fetch(
		`${api_base_url}/api/${api_key}/post/${userId}/darkweb/${scanUuid}/remediation`,
		{
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(update),
		}
	);
	const payload = await response.json().catch(() => ({}));
	if (!response.ok) {
		throw new Error(
			payload.message || "Unable to update the remediation workflow"
		);
	}
	return payload.data;
};

const providerRequest = async (userId, providerKey, method, body) => {
	const token = sessionStorage.getItem("authToken");
	const response = await fetch(
		`${api_base_url}/api/${api_key}/post/${userId}/darkweb/providers/${encodeURIComponent(providerKey)}`,
		{
			method,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			...(body ? { body: JSON.stringify(body) } : {}),
		}
	);
	const payload = await response.json().catch(() => ({}));
	if (!response.ok) {
		throw new Error(payload.message || "Unable to update the provider connector");
	}
	return payload.data;
};

export const configureDarkwebProvider = (userId, providerKey, credentials) =>
	providerRequest(userId, providerKey, "PUT", { credentials });

export const disconnectDarkwebProvider = (userId, providerKey) =>
	providerRequest(userId, providerKey, "DELETE");

export const configureHibpProvider = (userId, apiKey) =>
	configureDarkwebProvider(userId, "hibp", { apiKey });

export const disconnectHibpProvider = (userId) =>
	disconnectDarkwebProvider(userId, "hibp");
